import { GenericEntityConstantsEntities } from "./GenericConstants";
import { EntityConstants } from "./GenericTypes";

export const adminStatisticsConstants: EntityConstants = {
  resource: "admin",
  frontendIndexRoute: "admin",
  entitySingular: "Admin statistic",
  entityPlural: "Admin statistics",
  icon: "chart-bar",
};

export interface AdminStatisticsReadModel {
  entityCounts: {
    [entity in GenericEntityConstantsEntities]: number;
  };
  personStatistics: PersonStatisticsReadModel;
  fileFormatStatistics: {
    [parser: string]: FileFormatStatisticsReadModel;
  };
}

interface PersonStatisticsReadModel {
  personCount: number;
  personWithUserCount: number;
  personWithoutUserCount: number;
  personWithSSOCount: number;
  personWith2FACount: number;
}
interface FileFormatStatisticsReadModel {
  datasetCount: number;
  lastCreationDate: string | null;
  lastEnteredOnDate: string | null;
  accumulatedDatasetSize: number;
  accumulatedCacheSize: number;
}
